import React, { useEffect, useState } from 'react';
import { useOmniAgent } from '../../context/OmniAgentContext';

export default function ConversationHeader() {
  const { sessions = [], activeSessionId, renameSession, pinSession, deleteSession, isProcessing } = useOmniAgent();
  const session = sessions.find(s => s.id === activeSessionId);
  const [editing, setEditing] = useState(false);
  const [title, setTitle] = useState('');
  useEffect(() => { setEditing(false); }, [activeSessionId]);
  if (!session) return null;
  return (
    <header className="ag-conversation-header">
      {editing ? (
        <form onSubmit={e => { e.preventDefault(); if (title.trim()) { renameSession(session.id, title.trim()); setEditing(false); } }}>
          <input autoFocus aria-label="Conversation title" value={title} maxLength={200} onChange={e => setTitle(e.target.value)} onKeyDown={e => { if (e.key === 'Escape') setEditing(false); }} />
          <button type="submit">Save</button>
          <button type="button" onClick={() => setEditing(false)}>Cancel</button>
        </form>
      ) : <span className="ag-conversation-title">{session.title || 'New chat'}</span>}
      <details className="ag-conversation-menu">
        <summary aria-label="Conversation options"><span className="material-symbols-rounded" aria-hidden="true">more_horiz</span></summary>
        <div>
          <button type="button" onClick={() => { setTitle(session.title || ''); setEditing(true); }}>Rename</button>
          <button type="button" onClick={() => pinSession(session.id, !session.isPinned)}>{session.isPinned ? 'Unpin' : 'Pin'}</button>
          <button type="button" disabled={isProcessing} onClick={() => deleteSession(session.id)}>Delete</button>
        </div>
      </details>
    </header>
  );
}
